import React from "react";
import WhatwedoBglanding from "./WhatwedoBglanding";
import WhatwedoHeading from "./WhatwedoHeading";
import { Box, Typography } from "@mui/material";
import WhatwedoContent from "./WhatwedoContent";
import { Helmet } from "react-helmet";

const whatwedo3 = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | On-Demand Analytics</title>
        <meta
          name="description"
          content="From predictive modeling to localized demand estimation, our approach drives growth and efficiency."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <WhatwedoBglanding />
        <WhatwedoHeading />
        <WhatwedoContent />
        <Typography
          sx={{
            textAlign: "left",
            color: "rgba(51, 51, 51, 1)",
            fontFamily: "Plus Jakarta Sans",
            padding: { xs: "1rem", sm: "1rem 0 1rem 4rem" },
          }}
        >
          Partner with us to unlock the power of innovative on-demand analytics
          and stay ahead of the competition in today's fast-paced business
          environment.
        </Typography>
      </Box>
    </>
  );
};

export default whatwedo3;
